import React, { useEffect, useState } from "react";
import { Card, Button, TextField, Box, palette } from "@material-ui/core";
import { useStyles } from "../../../styles/styles";
import { useDispatch, useSelector } from "react-redux";
import {
    LoadCustomersListAction,
    UpdateCustomerAction,
    CustomerDeleteAction
} from "../../../redux/actions/ProfileActions";
import SimpleMenu from "../../../components/layouts/Navigation";
import { DataGrid } from "@material-ui/data-grid";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import DeleteIcon from "@material-ui/icons/Delete";
import ViewIcon from "@material-ui/icons/RemoveRedEye";
import EditIcon from "@material-ui/icons/Edit";
import SearchBar from "material-ui-search-bar";
import { useHistory, Link } from "react-router-dom";
import {
    createStyles,
    Theme,
    withStyles,
    WithStyles,
} from "@material-ui/core/styles";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import RadioGroup from "@material-ui/core/RadioGroup";
import Radio from "@material-ui/core/Radio";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import ArrowBackRounded from "@material-ui/icons/ArrowBackRounded";
import logo from "../../../logo.png";
import { RegisterAction } from "../../../redux/actions/AuthActions";
import * as ActionTypes from "../../../redux/ActionTypes";
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/material.css'
import AuthorizationErrorComponent from '../../AuthorizationErrorComponent';
const styles = (theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(2),
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: theme.palette.grey[500],
    },
});
const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
        <MuiDialogTitle disableTypography className={classes.root} {...other}>
            <Typography variant="h6">{children}</Typography>
            {onClose ? (
                <IconButton
                    aria-label="close"
                    className={classes.closeButton}
                    onClick={onClose}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </MuiDialogTitle>
    );
});

const DialogContent = withStyles((theme) => ({
    root: {
        padding: theme.spacing(2),
    },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
    root: {
        margin: 0,
        padding: theme.spacing(1),
    },
}))(MuiDialogActions);
export default function CustomerListing(props) {
    const history = useHistory();
    const classes = useStyles();
    const dispatch = useDispatch();

    const usersListResponse = useSelector((state) => state.userDetails.usersList);
    const users = useSelector((state) => state.userDetails.users);
    const [searched, setSearched] = useState("");
    const [rows, setRows] = useState([]);

    const [restrictedStatus, setRestrictedStatus] = useState(false);
    const [restrictedResponse, setRestrictedResponse] = useState("");
    const [bodyStatus, setBodyStatus] = useState(false);
    const [customerEditFlag,setCustomerEditFlag] = useState(false);

    const [showPassword, setShowPassword] = useState(false);
    const [fields, setState] = useState({
        name: "",
        email: "",
        password: "",
        first_name: "",
        last_name: "",
        contact_no: "",
        password_confirmation: "",
        id: null,
        changeStatus: false,
        is_active:false
    });

    const columns = [
        { field: "id", headerName: "ID", width: 130 },
        { field: "name", headerName: "Name", width: 200 },
        // { field: "first_name", headerName: "First Name", width: 130 },
        // { field: "last_name", headerName: "Last Name", width: 130 },
        { field: "contact_no", headerName: "Phn", width: 130 },
        { field: "email", headerName: "Email", width: 200 },
        // {field: "gender", headerName: "Gender", width: 130 },
        // { field: "date_of_birth", headerName: "DOB", width: 150 },
        { field: "is_active", headerName: "Status", width: 150},
        {
            field: "actions",
            headerName: "Actions",
            width: 130,
            renderCell: (cellValues) => {
                return (
                    <div
                        style={{
                            textAlign: "center",
                            paddingLeft: "15px",
                            paddingRight: "15px",
                        }}
                    >
                       
                      {customerEditFlag && <EditIcon
                            color="primary"
                            onClick={(event) => {
                                editUser(event, cellValues);
                            }}
                        />} {" "}
                        <ViewIcon style={{color:"green"}}
                            onClick={(event) => {
                                history.push('/customer-details/' + cellValues.row.id)
                            }}
                        />
                    </div>
                );
            },
        },
    ];
  
    const editUser = (event, param) => {
     
        setState({
            ...fields,
            first_name: param.row.first_name,
            last_name: param.row.last_name,
            contact_no: param.row.contact_no,
            email: param.row.email,
            name: param.row.name,
            id: param.row.id,
            createStatus:false,
            changeStatus: false,
            fieldStatus: false, //control status of messages
            renderStatus:false, // cross render
            gender: param.row.gender,
            date_of_birth: param.row.date_of_birth,
            is_active: (param.row.is_active !== null && param.row.is_active === "Inactive") ? "Inactive" :"Active"
        });
        dispatch({ type: ActionTypes.FREE_USER_STATE, usersListResponse });
       

        setOpen(true);
    };
    const deleteUser = (event, param) => {
        event.stopPropagation();
        dispatch(CustomerDeleteAction(param.row, history));
    };
    const requestSearch = (searchedVal) => {
        const filteredRows = users.filter((row) => {
            return row.name.toLowerCase().includes(searchedVal.toLowerCase());
        });
        setRows(filteredRows);
    };
    const [open, setOpen] = React.useState(false);

    const handleClose = () => {
        
        dispatch({ type: ActionTypes.FREE_USER_STATE, usersListResponse });
        setState({
            ...fields,
            name: "",
            email: "",
            password: "",
            first_name: "",
            last_name: "",
            contact_no: "",
            password_confirmation: "",
            id: null,
            changeStatus: false,
            fieldStatus: false,
            gender: '',
            date_of_birth: '',
            is_active:"",
            renderStatus:true,
        });
        setOpen(false);
    };
    const cancelSearch = () => {
        setSearched("");
        requestSearch(searched);
    };

    /*Edit User Functionalities Section */

    const handleFieldChange = (e) => {
        
        if (fields[e.target.id] != e.target.value) {
           
            setState({
                ...fields, changeStatus: true,
                fieldStatus: false,

                [e.target.id]: e.target.value,
            })

           
        }
        if (e.target.id==='is_active'){
          
            setState({
                ...fields, changeStatus: true,
                fieldStatus: false,
                [e.target.id]: e.target.value,
            })
        }

    };
    
  
    const handleFieldChangeRadio = (e) => { 
       
            setState({
                ...fields, changeStatus: true,
                fieldStatus: false,
                [e.target.name]: e.target.value,
            })
       
    }

    const handleFieldChangePhone = (value) => {
        
        if (fields['contact_no'] != value) {
            
            setState({
                ...fields, changeStatus: true,
                 fieldStatus:false,
                'contact_no': value,
            })
        }
    }
    const checkPasswordMatch = (password, password_confirmation) => {
        return password !== password_confirmation ? true : false;
    };

    const UpdateUser = (e) => {
        e.preventDefault();
        setState({
            ...fields, changeStatus: false,fieldStatus:false
        });
         
        const passwordMatch = checkPasswordMatch(
            fields.password,
            fields.password_confirmation
        );

        if (passwordMatch === true) {
            alert("passwords dont match. please check your password again");
            return;
        }
        dispatch(UpdateCustomerAction(fields,setState));
        setRows(users);
       
    };
    
    const showPasswordControl = () => {
        setShowPassword(!showPassword);
    }

    /*End of Edit User Functionalities Section */
    useEffect(() => {
        let abortController;
        abortController = new AbortController();
        let signal = abortController.signal;  
        dispatch(LoadCustomersListAction(setRows, setRestrictedResponse, setRestrictedStatus, setBodyStatus, signal, setCustomerEditFlag));
      

        return () => {
            abortController.abort();
         };
    }, [fields.renderStatus==true]);

    return (
        <>
            <div className={classes.root}>
                {restrictedStatus &&
                    <> <Grid container className={classes.bodyWrapper}>
                        <Grid item xs={12} style={{ height: "100vh" }}> <AuthorizationErrorComponent error={restrictedResponse.message} />

                        </Grid>
                    </Grid>
                    </>
                }
                {!restrictedStatus && bodyStatus &&
                <Grid container className={classes.bodyWrapper}>
                    <Grid item xs={2}>
                        <Paper className={classes.paper}>
                            
                        </Paper>
                    </Grid>

                        <Grid item md={10}  xs={10}  className={classes.rightSideContent} style={{ marginTop: "25px" }}>
                            <Grid xl={12}>
                                <Grid item xs={10} md={3} className={classes.searchBox} style={{ paddingTop: "10px", marginBottom: "10px" }}>
                                    <SearchBar
                                        value={searched}
                                        onChange={(searchVal) => requestSearch(searchVal)}
                                        onCancelSearch={() => cancelSearch()}
                                    />
                                </Grid>
                                <Grid item xs={10} className={classes.searchBox} >
                            <div className={classes.MuiDataGrid_windowContainer}>
                                {users.length !== 0 ? (
                                    <DataGrid
                                        rows={rows}
                                        columns={columns}
                                        pageSize={15}
                                        rowsPerPageOptions={[15]}
                                        //checkboxSelection
                                        disableSelectionOnClick
                                    />
                                ) : (
                                    <div className={classes.beforeLoad}>
                                        Displaying Users List...
                                    </div>
                                )}
                            </div>
                                </Grid>
                        </Grid>
                        <div>
                            <Dialog
                                onClose={handleClose}
                                aria-labelledby="customized-dialog-title"
                                open={open}
                                fullWidth
                                maxWidth="lg"
                            >
                                <DialogTitle id="customized-dialog-title" onClose={handleClose}>
                                    <b
                                        className={classes.primary}
                                        style={{ textAlign: "center" }}
                                    >
                                        Edit User
                                    </b>
                                </DialogTitle>
                                <DialogContent dividers>
                                    {usersListResponse.success == false &&
                                        usersListResponse.updatedUser != "" &&
                                        fields.fieldStatus == true ? (
                                        <div className={classes.customFail}>
                                            {usersListResponse.message}
                                        </div>
                                    ) : usersListResponse.success == true &&
                                        usersListResponse.updatedUser &&
                                        fields.fieldStatus == true ? (
                                        <div className={classes.customSuccess}>
                                            {usersListResponse.message}
                                        </div>
                                    ) : (
                                        ""
                                    )}
                                    <form >
                                        <Grid container item xs={12}>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="text"
                                                    className={classes.fullWidth}
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="First Name"
                                                    id="first_name"
                                                    value={fields.first_name}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="text"
                                                    className={classes.fullWidth}
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Last Name"
                                                    id="last_name"
                                                    value={fields.last_name}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="text"
                                                    className={classes.fullWidth}
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Full Name"
                                                    id="name"
                                                    value={fields.name}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <TextField
                                                    type="email"
                                                    className={classes.fullWidth}
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Email"
                                                    id="email"
                                                    value={fields.email}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            <Grid item xs={6}>
                                                <PhoneInput
                                                    required
                                                    margin="normal"
                                                    variant="outlined"
                                                    label="Contact Number"
                                                    country="np"
                                                    placeholder="9843125689"
                                                    name='contact_no'

                                                    containerStyle={{
                                                        marginTop: "20px",
                                                        marginBottom: "25px"
                                                    }}
                                                    inputStyle={{ width: "80%", verticleAlign: "middle", borderColor: (props.touched && props.error) && "red" }}

                                                    onlyCountries={['np']}
                                                    value={fields.contact_no}
                                                    onChange={(value, country, e, formattedValue) => handleFieldChangePhone(value, country, e, formattedValue)}
                                                    disableDropdown
                                                    disableCountryCode
                                                    isValid={(value, country) => {
                                                        var reg = new RegExp('^((98))[0-9]{8}$', 'i');
                                                        if (!reg.test(value)) {
                                                            return false;
                                                        }
                                                        if (value.length == 10) {
                                                            return true;
                                                        } else {
                                                            return false;
                                                        }
                                                    }}
                                                />

                                            </Grid>
                                            <Grid item xs={6} >
                                                <FormControl variant="outlined" className={classes.formControl}>
                                                    <div>


                                                        <TextField
                                                            id="date_of_birth"
                                                            name="date_of_birth"
                                                            type="date"
                                                            margin="normal"
                                                            required
                                                            variant="outlined"
                                                            label="Date of Birth"
                                                            value={fields.date_of_birth}
                                                            onChange={handleFieldChange}
                                                                inputlabelprops={{
                                                                shrink: true,
                                                            }}
                                                        />
                                                    </div>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={6} style={{ marginTop: "20px" }}>
                                                <FormControl variant="outlined" className={classes.formControl}>
                                                    <FormLabel>Gender*</FormLabel>
                                                    <RadioGroup
                                                        required
                                                        name="gender"
                                                        value={fields.gender}
                                                        onChange={handleFieldChangeRadio}
                                                        row
                                                    >
                                                        <FormControlLabel
                                                            required
                                                            key="male"
                                                            value="male"
                                                            control={<Radio size="small" />}
                                                            label="Male"
                                                        />
                                                        <FormControlLabel
                                                            key="female"
                                                            value="female"
                                                            control={<Radio size="small" />}
                                                            label="Female"
                                                        />
                                                        <FormControlLabel
                                                            key="other"
                                                            value="other"
                                                            control={<Radio size="small" />}
                                                            label="Other"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>

                                            </Grid>
                                              
                                                    <Grid item xs={12}>
                                                        <Button onClick={showPasswordControl} className={[classes.customButton].join(" ")}
                                                            orientation="vertical"
                                                            aria-label="vertical contained button group"
                                                            variant="contained"
                                                            color="primary"
                                                            style={{ clear: "both" }}>
                                                            {showPassword ? "Hide Password" : "Show Password"}
                                                        </Button>
                                                    </Grid>
                                              
                                            {showPassword &&
                                            <Grid item xs={6}>
                                                <TextField
                                                    className={classes.fullWidth}
                                                    label="Password"
                                                    type="password"
                                                    margin="normal"
                                                    variant="outlined"
                                                    id="password"
                                                    value={fields.password}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            }
                                            {showPassword &&
                                            <Grid item xs={6}>
                                                <TextField
                                                    className={classes.fullWidth}
                                                    label="Confirm Password"
                                                    type="password"
                                                    margin="normal"
                                                    variant="outlined"
                                                    id="password_confirmation"
                                                    value={fields.password_confirmation}
                                                    onChange={handleFieldChange}
                                                />
                                            </Grid>
                                            }
                                            <Grid item xs={6}>
                                            <FormControl>
                                                <FormLabel>Customer Status</FormLabel>
                                                <RadioGroup
                                                        name="is_active"
                                                        id="is_active"
                                                        value={fields.is_active}
                                                        onChange={handleFieldChangeRadio}
                                                    row
                                                >        
                                                    <FormControlLabel
                                                            key="Active"
                                                            value="Active"
                                                        control={<Radio size="small" />}
                                                        label="Active"
                                                        variant="outlined"
                                                            checked={fields.is_active == "Active" ?true:false} 
                                                    />
                                                    <FormControlLabel
                                                            key="Inactive"
                                                            value="Inactive"
                                                        control={<Radio size="small" />}
                                                        label="Inactive"
                                                        variant="outlined"
                                                            checked={fields.is_active == "Inactive" ? true : false} 
                                                    />
                                                </RadioGroup>
                                            </FormControl>
                                            </Grid>

                                        </Grid>
                                    </form>
                                </DialogContent>
                                <DialogActions>
                                    <Button autoFocus onClick={UpdateUser} className={[classes.customButton].join(" ")}
                                        orientation="vertical"
                                        aria-label="vertical contained button group"
                                        variant="contained"
                                        color="primary"
                                        style={{ clear: "both" }}>
                                        Save changes
                                    </Button>
                                </DialogActions>
                            </Dialog>
                        </div>
                    </Grid>
                </Grid>
                }
            </div>
        </>
    );
}
